'use client';

import { Suspense } from 'react';
import { DataList } from '@/components/Shared/DataList';
import { Table } from '@/lib/types/Table';
import { TableAttributesSkeleton } from './TableAttributesSkeleton';
const classes = {
  wrapper: 'p-5 bg-white',
  group: 'text-sm font-mono flex flex-col gap-5',
  item: 'flex gap-10 [&_span:first-of-type]:w-4/12 [&_span:last-of-type]:w-8/12 [&_span:last-of-type]:break-all'
};
interface TableAttributesProps {
  table: Table;
}
export function TableAttributes({
  table
}: TableAttributesProps) {
  const id = `table-${table.id}-attributes`;
  const data = {
    id: table.id,
    database_name: table.database_name,
    table_name: table.name,
    table_adapter: table.adapter
  };
  return <Suspense fallback={<TableAttributesSkeleton />}>
      <div className={classes.wrapper}>
        <DataList data={data} id={id} />
      </div>
    </Suspense>;
}